import React from 'react';
import { Box, Typography } from '@mui/material';
import { companyInfoLabelSx, companyInfoRequiredMarkSx } from './companyInfoStyles';

const CompanyInfoLabel = ({ children, htmlFor, required = false, sx }) => (
  <Typography component="label" htmlFor={htmlFor} sx={{ ...companyInfoLabelSx, ...sx }}>
    {children}
    {required ? (
      <Box component="span" sx={companyInfoRequiredMarkSx} aria-hidden="true">
        *
      </Box>
    ) : null}
  </Typography>
);

export default CompanyInfoLabel;
